import { TitleBlockWrapper } from '@anm/components/TitleBlock';
import { flexColumn, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const firstSectionTablet = media.tablet`
  margin-top: 0;
`;

const UserProfileWrapper = styled.div`
  ${flexColumn};
  margin: 0 auto;
  padding: 0 10px;
  align-items: center;
  max-width: 840px;
  overflow: visible!important;
  > * {
    width: 100%;
    margin-top: 36px;
    &:first-child {
      margin-top: 40px;
      ${firstSectionTablet};
    }
  }
  input {
    margin-bottom: 20px;
  }
  ${TitleBlockWrapper} {
    margin-bottom: 21px;
  }
`;

export const UserFormWrapper = styled.div`
  margin: 0;
`;

export default UserProfileWrapper;
